var appVersion = [
  {"version": "1.0", date: '1398/04/28'},
  {"version": "1.1", date: '1398/04/28'},
  {"version": "1.2", date: '1398/04/29'},
  {"version": "1.3", date: '1398/04/30'},
  {"version": "1.4", date: '1398/04/31'},
];

export default appVersion;
